import { useEffect, useState } from "react"
import { Spinner } from "../../spinner/spinner"

export type Props = {
    loadFn: () => Promise<JSX.Element>
    showSpinner?: boolean
    deps?: React.DependencyList
}

export const Async = (props: Props) => {
    const { loadFn, showSpinner = false, deps } = props
    const [value, setValue] = useState<JSX.Element>()
  
    const load = async () => {
        setValue(await loadFn())
    }

    useEffect(() => {
        load()
    }, [deps])
  
    return value && !showSpinner ? value : <Spinner centered={false} />
}
